import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.rolle-loeschen';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungRolleLoeschenEffects {

    RolleLoeschen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_ROLLE_LOESCHEN),
        mergeMap((x: ac.PostRolleLoeschenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postRolleLoeschen(x.rolleRequest).pipe(
                map((result: any) => {
                    return new ac.PostRolleLoeschenErfolgreichAction(result, x.rolleRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostRolleLoeschenFehlerAction(error, x.rolleRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.RollenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.RollenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.RollenCommandService);
        }
        return this.service;
    }
}
